export const environment = {
  production: false,
  USERS_API_URL: 'https://apis-staging.manhattanprep.com/v1/users',
  ATLAS_URL: 'https://staging.manhattanprep.com/atlas',
  BASE_DOMAIN: 'https://staging.manhattanprep.com',
  KAP_GTM_ID: 'GTM-MTB788M'
}
